export class RegisterUsers {
  name: string = ""
  document: string = ""
  login: string = ""
  password: string = ""
}

export enum Role {
  superadmin = 1,
  admin = 2,
  espectador = 3,
  investidor = 4,
  produtor = 5,
  prestador_servico = 6,
}